import {Injectable} from "@angular/core";
import {PRODUCTS} from "./mock-products";

@Injectable()
export class ProductService {

  getProducts(){
    return PRODUCTS;
  }

  getProduct(id: number){
    return PRODUCTS.find(p => p.id === id);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/product.service.ts